import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { AuthorizedDriverModifyRequest } from "./AuthorizedDriverModifyRequest";
import { PreferenceGetRequest } from "./PreferenceGetRequest";
import { DriverImportRequest } from "./DriverImportRequest";

@Injectable()
export class DataService_AuthorizedDrivers {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	AuthorizedDriverSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverModify(parms: AuthorizedDriverModifyRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverModify";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverToggle(DriverVerifyAuthID, Active) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverToggle?DriverVerifyAuthID=" + DriverVerifyAuthID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverDelete(DriverVerifyAuthID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverDelete?DriverVerifyAuthID=" + DriverVerifyAuthID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PreferenceGet(parms: PreferenceGetRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/PreferenceGet";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverFormatSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverImportFormatSelectList?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverImport(parms: DriverImportRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverImport";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverClearOverride(DriverVerifyAuthID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverClearOverride?DriverVerifyAuthID=" + DriverVerifyAuthID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AuthorizedDriverDeleteInactive() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/AuthorizedDriverDeleteInactive?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
